import React from "react";
import { HashRouter } from "react-router-dom";
import AppRoute from "./app-route";
import { Switch } from "react-router-dom";
import SignIn from "./auth/containers/sign-in";
import ForgotPassword from "./auth/containers/forgot-password";
import Home from "./home/containers/home";
import SettingsWrapper from "./account/components/settings-wrapper";
import UpdatePasswordWrapper from "./account/components/update-password-wrapper";
import NewPassword from "./auth/containers/new-password";
import NotFound from "./not-found";

export var routes = function() {
  return (
    <HashRouter>
      <div id="wrapper">
        <Switch>
          <AppRoute exact type="public" path="/" component={SignIn} />
          <AppRoute type="public" path="/signin" component={SignIn} />
          <AppRoute
            type="public"
            path="/forgot-password"
            component={ForgotPassword}
          />
          <AppRoute type="private" path="/home" component={Home} />
          <AppRoute
            type="private"
            path="/settings"
            component={SettingsWrapper}
          />
          <AppRoute
            type="private"
            path="/update-password"
            component={UpdatePasswordWrapper}
          />
          <AppRoute
            type="public"
            path="/user/:id/passwords/new/:token"
            component={NewPassword}
          />
          <AppRoute
            type="private"
            path="/payment-methods/delete/:id"
            component={Home}
          />
          <AppRoute
            type="private"
            path="/plans/:paymentId/payments/new"
            component={Home}
          />
          <AppRoute
            type="private"
            path="/plans/:paymentId/payments/:confirmationId"
            component={Home}
          />
          <AppRoute type="static" path="*" component={NotFound} />
        </Switch>
      </div>
    </HashRouter>
  );
};



// WEBPACK FOOTER //
// ./src/routes.js